var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-cropper{width:100px;height:100px;position:relative;overflow:hidden;border-radius:50%}.me_logo{background-image:url(" + escape(require("../assets/icons/me_logo.svg")) + ");background-size:contain;background-repeat:no-repeat;max-height:3em;width:3em;float:left}.profile-pic{height:3em;width:3em;float:left;object-fit:contain;border-radius:50%}input[type=checkbox]{-ms-transform:scale(2);-moz-transform:scale(2);-webkit-transform:scale(2);-o-transform:scale(2);transform:scale(2);padding:10px}.inputfile{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}#file_loader,#file_loader2{margin:0;padding:0;cursor:pointer}.border-danger{border:3px solid #da4453!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-507ea04c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Control.vue
// module id = 367
// module chunks = 0